import React, {Component} from 'react';
import axios from 'axios';

export default class CrabGourdBotSetting extends Component {
    constructor(props) {
        super(props);

        this.state = {
            botSetting: {
                enableBotCrabGourd: false,
                simulationRatePercent: 0,
                joinCommentRatePercent: 0,
                maxTotalChipCount: 0,
                maxTotalChipValue: 0,
                maxDurationBettingMs: 0,
                maxConsecutiveBetGapMs: 0
            },
        }

        this.fetchData = this.fetchData.bind(this);
        this.updateBotSetting = this.updateBotSetting.bind(this);
        this.createBotSetting = this.createBotSetting.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        axios.post(global.config.apiDomain + '/game/crab-gourd/web/get-bot-crab-gourd-setting')
        .then(res => {
            let data = res.data;
            if (data.status === 'OK' && data.data) {
                this.setState({
                    botSetting: {
                        enableBotCrabGourd: data.data.enableBotCrabGourd !== undefined ? data.data.enableBotCrabGourd : false,
                        simulationRatePercent: data.data.simulationRatePercent || 0,
                        joinCommentRatePercent: data.data.joinCommentRatePercent || 0,
                        maxTotalChipCount: data.data.maxTotalChipCount || 0,
                        maxTotalChipValue: data.data.maxTotalChipValue || 0,
                        maxDurationBettingMs: data.data.maxDurationBettingMs || 0,
                        maxConsecutiveBetGapMs: data.data.maxConsecutiveBetGapMs || 0
                    }
                });
            }
        }).catch(error => {
            console.error('Error fetching bot setting:', error);
            alert('Có lỗi xảy ra khi tải cài đặt BOT!');
        });
    }

    createBotSetting() {
        axios.post(global.config.apiDomain + '/game/crab-gourd/web/create-bot-crab-gourd-setting')
        .then(res => {
            if (res.data.status === 'OK') {
                alert('Tạo cài đặt BOT mặc định thành công!');
                this.fetchData(); // Reload data after creating
            } else {
                alert('Tạo cài đặt thất bại: ' + (res.data.message || 'Lỗi không xác định'));
            }
        }).catch(error => {
            console.error('Error creating bot setting:', error);
            alert('Có lỗi xảy ra khi tạo cài đặt BOT!');
        });
    }

    updateBotSetting() {
        const { botSetting } = this.state;
        
        // Validate required fields
        if (botSetting.enableBotCrabGourd === null || botSetting.enableBotCrabGourd === undefined ||
            botSetting.simulationRatePercent === '' || botSetting.simulationRatePercent === null || botSetting.simulationRatePercent === undefined ||
            botSetting.joinCommentRatePercent === '' || botSetting.joinCommentRatePercent === null || botSetting.joinCommentRatePercent === undefined ||
            botSetting.maxTotalChipCount === '' || botSetting.maxTotalChipCount === null || botSetting.maxTotalChipCount === undefined ||
            botSetting.maxTotalChipValue === '' || botSetting.maxTotalChipValue === null || botSetting.maxTotalChipValue === undefined ||
            botSetting.maxDurationBettingMs === '' || botSetting.maxDurationBettingMs === null || botSetting.maxDurationBettingMs === undefined ||
            botSetting.maxConsecutiveBetGapMs === '' || botSetting.maxConsecutiveBetGapMs === null || botSetting.maxConsecutiveBetGapMs === undefined) {
            alert('Vui lòng điền đầy đủ các trường bắt buộc!');
            return;
        }

        // Validate simulationRatePercent range (0-100)
        const simulationRate = parseInt(botSetting.simulationRatePercent);
        if (simulationRate < 0 || simulationRate > 100) {
            alert('Tỷ lệ mô phỏng phải nằm trong khoảng 0-100!');
            return;
        }

        // Validate joinCommentRatePercent range (0-100)
        const joinCommentRate = parseInt(botSetting.joinCommentRatePercent);
        if (joinCommentRate < 0 || joinCommentRate > 100) {
            alert('Tỷ lệ tham gia bình luận phải nằm trong khoảng 0-100!');
            return;
        }

        // Validate maxDurationBettingMs >= 1
        const maxDuration = parseInt(botSetting.maxDurationBettingMs);
        if (maxDuration < 1) {
            alert('Thời gian đặt cược tối đa phải lớn hơn hoặc bằng 1!');
            return;
        }

        const requestBody = {
            enableBotCrabGourd: botSetting.enableBotCrabGourd === true,
            simulationRatePercent: parseInt(botSetting.simulationRatePercent),
            joinCommentRatePercent: parseInt(botSetting.joinCommentRatePercent),
            maxTotalChipCount: parseInt(botSetting.maxTotalChipCount),
            maxTotalChipValue: parseInt(botSetting.maxTotalChipValue),
            maxDurationBettingMs: parseInt(botSetting.maxDurationBettingMs),
            maxConsecutiveBetGapMs: parseInt(botSetting.maxConsecutiveBetGapMs)
        };
        
        axios.post(global.config.apiDomain + '/game/crab-gourd/web/update-bot-crab-gourd-setting', requestBody, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            if (res.data.status === 'OK') {
                alert('Cập nhật cài đặt BOT thành công!');
            } else {
                alert('Cập nhật thất bại: ' + (res.data.message || 'Lỗi không xác định'));
            }
        }).catch(error => {
            console.error('Error updating bot setting:', error);
            alert('Có lỗi xảy ra khi cập nhật cài đặt BOT!');
        });
    }

    render() {
        const {botSetting} = this.state;

        const inputStyle = {
            border: '2px solid #e9ecef',
            borderRadius: '4px',
            padding: '10px 12px',
            fontSize: '14px',
            transition: 'border-color 0.3s ease'
        };

        const labelStyle = {
            fontWeight: '600',
            color: '#2c3e50',
            marginBottom: '8px',
            display: 'block'
        };

        return (
            <>
                <div id="content">
                    <div className="container-fluid">
                        <h1 className="text-center">Quản lý BOT Bầu Cua</h1>
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <div className="card" style={{
                                    border: 'none',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                    marginTop: '20px'
                                }}>
                                    <div className="card-body" style={{ padding: '30px' }}>
                                        <div className="form-group">
                                            <div style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'space-between',
                                                marginBottom: '25px',
                                                padding: '15px',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '8px',
                                                border: '1px solid #e9ecef'
                                            }}>
                                                <label style={{ 
                                                    ...labelStyle, 
                                                    marginBottom: '0', 
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flex: 1
                                                }}>
                                                    <i className="fas fa-power-off" style={{ 
                                                        marginRight: '10px', 
                                                        fontSize: '18px',
                                                        color: botSetting.enableBotCrabGourd ? '#27ae60' : '#95a5a6',
                                                        transition: 'color 0.3s ease'
                                                    }}></i>
                                                    <span style={{ fontSize: '15px' }}>Bật BOT Bầu Cua</span>
                                                </label>
                                                <div 
                                                    onClick={() => this.setState({
                                                        botSetting: {
                                                            ...botSetting,
                                                            enableBotCrabGourd: !botSetting.enableBotCrabGourd
                                                        }
                                                    })}
                                                    style={{
                                                        position: 'relative',
                                                        width: '60px',
                                                        height: '30px',
                                                        backgroundColor: botSetting.enableBotCrabGourd ? '#27ae60' : '#95a5a6',
                                                        borderRadius: '15px',
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.3s ease',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                        flexShrink: 0
                                                    }}
                                                >
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: '3px',
                                                        left: botSetting.enableBotCrabGourd ? '33px' : '3px',
                                                        width: '24px',
                                                        height: '24px',
                                                        backgroundColor: '#fff',
                                                        borderRadius: '50%',
                                                        transition: 'left 0.3s ease',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
                                                    }}></div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label style={labelStyle}>
                                                <i className="fas fa-percentage" style={{ marginRight: '8px', color: '#9b59b6' }}></i>
                                                Tỷ lệ mô phỏng (%) (simulationRatePercent)
                                            </label>
                                            <input 
                                                type="number"
                                                className="form-control"
                                                style={inputStyle}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#9b59b6';
                                                    e.target.style.boxShadow = '0 0 0 0.2rem rgba(155, 89, 182, 0.25)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e9ecef';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                                value={botSetting.simulationRatePercent || ''}
                                                onChange={(e) => this.setState({
                                                    botSetting: {
                                                        ...botSetting,
                                                        simulationRatePercent: e.target.value ? parseInt(e.target.value) : ''
                                                    }
                                                })}
                                                placeholder="Nhập tỷ lệ mô phỏng (0-100)..."
                                                min="0"
                                                max="100"
                                            />
                                        </div>

                                        <div className="form-group" style={{ marginTop: '20px' }}>
                                            <label style={labelStyle}>
                                                <i className="fas fa-comment" style={{ marginRight: '8px', color: '#16a085' }}></i>
                                                Tỷ lệ tham gia bình luận (%) (joinCommentRatePercent)
                                            </label>
                                            <input 
                                                type="number"
                                                className="form-control"
                                                style={inputStyle}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#16a085';
                                                    e.target.style.boxShadow = '0 0 0 0.2rem rgba(22, 160, 133, 0.25)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e9ecef';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                                value={botSetting.joinCommentRatePercent || ''}
                                                onChange={(e) => this.setState({
                                                    botSetting: {
                                                        ...botSetting,
                                                        joinCommentRatePercent: e.target.value ? parseInt(e.target.value) : ''
                                                    }
                                                })}
                                                placeholder="Nhập tỷ lệ tham gia bình luận (0-100)..."
                                                min="0"
                                                max="100"
                                            />
                                        </div>

                                        <div className="form-group" style={{ marginTop: '20px' }}>
                                            <label style={labelStyle}>
                                                <i className="fas fa-coins" style={{ marginRight: '8px', color: '#f39c12' }}></i>
                                                Số lượng chip tối đa (maxTotalChipCount)
                                            </label>
                                            <input 
                                                type="number"
                                                className="form-control"
                                                style={inputStyle}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#f39c12';
                                                    e.target.style.boxShadow = '0 0 0 0.2rem rgba(243, 156, 18, 0.25)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e9ecef';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                                value={botSetting.maxTotalChipCount || ''}
                                                onChange={(e) => this.setState({
                                                    botSetting: {
                                                        ...botSetting,
                                                        maxTotalChipCount: e.target.value ? parseInt(e.target.value) : ''
                                                    }
                                                })}
                                                placeholder="Nhập số lượng chip tối đa..."
                                                min="0"
                                            />
                                        </div>

                                        <div className="form-group" style={{ marginTop: '20px' }}>
                                            <label style={labelStyle}>
                                                <i className="fas fa-dollar-sign" style={{ marginRight: '8px', color: '#27ae60' }}></i>
                                                Giá trị chip tối đa (maxTotalChipValue)
                                            </label>
                                            <input 
                                                type="number"
                                                className="form-control"
                                                style={inputStyle}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#27ae60';
                                                    e.target.style.boxShadow = '0 0 0 0.2rem rgba(39, 174, 96, 0.25)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e9ecef';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                                value={botSetting.maxTotalChipValue || ''}
                                                onChange={(e) => this.setState({
                                                    botSetting: {
                                                        ...botSetting,
                                                        maxTotalChipValue: e.target.value ? parseInt(e.target.value) : ''
                                                    }
                                                })}
                                                placeholder="Nhập giá trị chip tối đa..."
                                                min="0"
                                            />
                                        </div>

                                        <div className="form-group" style={{ marginTop: '20px' }}>
                                            <label style={labelStyle}>
                                                <i className="fas fa-clock" style={{ marginRight: '8px', color: '#3498db' }}></i>
                                                Thời gian đặt cược tối đa (ms) (maxDurationBettingMs)
                                            </label>
                                            <input 
                                                type="number"
                                                className="form-control"
                                                style={inputStyle}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#3498db';
                                                    e.target.style.boxShadow = '0 0 0 0.2rem rgba(52, 152, 219, 0.25)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e9ecef';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                                value={botSetting.maxDurationBettingMs || ''}
                                                onChange={(e) => this.setState({
                                                    botSetting: {
                                                        ...botSetting,
                                                        maxDurationBettingMs: e.target.value ? parseInt(e.target.value) : ''
                                                    }
                                                })}
                                                placeholder="Nhập thời gian đặt cược tối đa (milliseconds)..."
                                                min="1"
                                            />
                                        </div>

                                        <div className="form-group" style={{ marginTop: '20px' }}>
                                            <label style={labelStyle}>
                                                <i className="fas fa-hourglass-half" style={{ marginRight: '8px', color: '#e74c3c' }}></i>
                                                Khoảng cách giữa các lần đặt cược liên tiếp (ms) (maxConsecutiveBetGapMs)
                                            </label>
                                            <input 
                                                type="number"
                                                className="form-control"
                                                style={inputStyle}
                                                onFocus={(e) => {
                                                    e.target.style.borderColor = '#e74c3c';
                                                    e.target.style.boxShadow = '0 0 0 0.2rem rgba(231, 76, 60, 0.25)';
                                                }}
                                                onBlur={(e) => {
                                                    e.target.style.borderColor = '#e9ecef';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                                value={botSetting.maxConsecutiveBetGapMs || ''}
                                                onChange={(e) => this.setState({
                                                    botSetting: {
                                                        ...botSetting,
                                                        maxConsecutiveBetGapMs: e.target.value ? parseInt(e.target.value) : ''
                                                    }
                                                })}
                                                placeholder="Nhập khoảng cách giữa các lần đặt cược (milliseconds)..."
                                                min="0"
                                            />
                                        </div>

                                        <div className="form-group" style={{ marginTop: '30px' }}>
                                            <div className="row">
                                                <div className="col-md-6" style={{ marginBottom: '10px' }}>
                                                    <button 
                                                        className="btn btn-success btn-block"
                                                        style={{
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            padding: '12px 24px',
                                                            fontWeight: '500',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                                            transition: 'all 0.3s ease',
                                                            fontSize: '16px'
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.target.style.transform = 'translateY(-1px)';
                                                            e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.target.style.transform = 'translateY(0)';
                                                            e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                                                        }}
                                                        onClick={() => this.createBotSetting()}
                                                    >
                                                        <i className="fas fa-plus" style={{ marginRight: '8px' }}></i>
                                                        Tạo cài đặt mặc định
                                                    </button>
                                                </div>
                                                <div className="col-md-6">
                                                    <button 
                                                        className="btn btn-primary btn-block"
                                                        style={{
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            padding: '12px 24px',
                                                            fontWeight: '500',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                                            transition: 'all 0.3s ease',
                                                            fontSize: '16px'
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.target.style.transform = 'translateY(-1px)';
                                                            e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.target.style.transform = 'translateY(0)';
                                                            e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                                                        }}
                                                        onClick={() => this.updateBotSetting()}
                                                    >
                                                        <i className="fas fa-save" style={{ marginRight: '8px' }}></i>
                                                        Cập nhật cài đặt BOT
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
